import { createAuthClient } from 'better-auth/react';
import { apiKeyClient, organizationClient, adminClient, deviceAuthorizationClient } from "better-auth/client/plugins";
import { ac, owner, admin, member, viewer } from '@/config/access-control.config';

// Create the better-auth client instance with plugins
export const authClient = createAuthClient({
  plugins: [
    organizationClient({
      ac,
      roles: {
        owner,
        admin,
        member,
        viewer,
      },
    }),
    apiKeyClient(),
    adminClient(),
    deviceAuthorizationClient(), // Add device authorization plugin
  ],
  fetchOptions: {
    onError: (error) => {
      console.error('Auth error:', error);
    },
    onSuccess: (data) => {
      // Log successful auth operations for debugging
      console.log('Auth operation successful:', data);
    }
  }
});

// Destructure the client methods
export const { signIn, signOut, signUp, useSession, organization } = authClient;